import { useCategories } from '@/features/pos/components/ProductCatalog/hooks/useCategories'
import { useContainers } from '@/features/pos/components/ProductCatalog/hooks/useContainers'
import { useSelectedCategory } from '@/features/pos/components/ProductCatalog/hooks/useSelectedCategory'
import { paddingHorizontal } from '@/features/pos/components/ProductCatalog/parts/CategoriesWithProducts/constants'
import CategoryBar from '@/features/pos/components/ProductCatalog/parts/CategoryBar'
import ProductList from '@/features/pos/components/ProductCatalog/parts/ProductList'
import { useSearchProduct } from '@/features/pos/hooks/search-product/useSearchProduct'
import { useScreenLayout } from '@/hooks/screen'
import { FC, memo, useDeferredValue } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

const CategoriesWithProducts: FC = () => {
    const containers = useContainers()

    const categories = useCategories(!!containers?.length)

    const [{ id, subcategoryId }, updateSelectedCategory] = useSelectedCategory()

    const searchProduct = useSearchProduct()

    const deferredSearchProduct = useDeferredValue(searchProduct)

    const layout = useScreenLayout()

    const { styles } = useStyles(stylesheet, { layout })

    return (
        <View style={styles.outerContainer}>
            <View style={styles.innerContainer}>
                {!deferredSearchProduct && (
                    <CategoryBar
                        categories={categories}
                        selectedId={id}
                        selectedSubcategoryId={subcategoryId}
                        horizontal={layout === 'compact'}
                        onPress={updateSelectedCategory}
                    />
                )}
                <View style={styles.productListContainer}>
                    <ProductList
                        categoryId={id}
                        containers={containers}
                        subcategoryId={subcategoryId}
                        searchProduct={deferredSearchProduct}
                    />
                </View>
            </View>
        </View>
    )
}

const stylesheet = createStyleSheet({
    outerContainer: {
        flex: 1,
        gap: 24,
        variants: {
            layout: {
                extended: {
                    paddingHorizontal,
                },
            },
        },
    },
    innerContainer: {
        flex: 1,
        gap: 16,
        variants: {
            layout: {
                extended: {
                    flexDirection: 'row',
                },
            },
        },
    },
    productListContainer: {
        flex: 1,
        variants: {
            layout: {
                compact: {
                    paddingHorizontal,
                },
            },
        },
    },
})

export default memo(CategoriesWithProducts)
